import { Box, Typography } from '@mui/material'

/**
 * The wordmark.
 *
 * It exists as a component because it was spelled out twice — in `AppShell` and
 * in `NoAccessScreen` — both times as `variant="h4"`, which is also the variant
 * every panel title used. The brand and a panel heading were literally the same
 * rank, which is why nothing on screen established one.
 *
 * The dot is drawn from `secondary.main` rather than `primary.main`: primary is
 * indigo and marks what is INTERACTIVE here, and a brand that borrows the
 * interactive colour teaches the wrong affordance on every screen.
 */
export function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const fontSize = size === 'lg' ? '1.75rem' : '1.125rem'
  const dot = size === 'lg' ? 7 : 5
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
      <Box
        aria-hidden
        sx={{
          width: dot,
          height: dot,
          borderRadius: '50%',
          bgcolor: 'secondary.main',
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{ fontSize, fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1 }}
      >
        Fintela
      </Typography>
    </Box>
  )
}
